import { FC, useEffect, useRef } from 'react'
import { useMediaQuery } from 'usehooks-ts'
import { ToastProps } from './types'
import { toast } from './config'

export const Toast: FC<ToastProps> = ({
  children,
  close,
  className,
  variant,
  autoClose,
  icon,
  closeLabel = 'Close',
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)')
  const closeRef = useRef(close)

  useEffect(() => {
    closeRef.current = close
  }, [close])

  useEffect(() => {
    if (autoClose ?? (variant !== 'danger' && variant !== 'warning')) {
      const timer = setTimeout(() => closeRef.current(), 3000)
      return () => clearTimeout(timer)
    }
  }, [autoClose, variant])

  const getVariant = () => {
    if (!isMobile) return variant

    if (variant === 'success') return 'mobileSuccess'
    if (variant === 'danger') return 'mobileDanger'
    return variant
  }

  const toastVariant = getVariant()

  return (
    <div
      role="status"
      className={toast({
        className,
        variant: toastVariant,
      })}
    >
      {icon ?? (
        <svg
          aria-hidden="true"
          className="flex-shrink-0 inline w-5 h-5"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clipRule="evenodd"
          />
        </svg>
      )}

      <div className="min-w-0 flex-1 break-words">{children}</div>

      {(variant !== 'success' || autoClose === false) && (
        <button
          type="button"
          onClick={close}
          className="ml-auto shrink-0 self-start bg-white/70 text-slate-500 hover:text-slate-900 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 p-1.5 hover:bg-white inline-flex h-8 w-8 transition-colors"
          aria-label={closeLabel}
        >
          <svg
            aria-hidden="true"
            className="w-5 h-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}
    </div>
  )
}
